import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import styles from './VisualDecisionGuide.module.scss'

const VisualDecisionGuide = ({
  id = 'visual-decision-guide',
  eyebrow = 'Choose the right format',
  heading,
  description,
  density = 'default',
  items = []
}) => {
  if (!heading || !items.length) return null

  const headingId = `${id}-title`
  const isCompact = density === 'compact'

  return (
    <section
      id={id}
      className={`${styles.section} ${isCompact ? styles.compact : ''}`.trim()}
      aria-labelledby={headingId}
    >
      <Container className={isCompact ? styles.compactContainer : ''}>
        <header className={styles.heading}>
          {eyebrow && <span>{eyebrow}</span>}
          <h2 id={headingId} data-section-focus-target>{heading}</h2>
          {description && <p>{description}</p>}
        </header>

        <div
          className={`${styles.grid} ${isCompact && items.length === 2 ? styles.twoColumnGrid : ''}`.trim()}
        >
          {items.map((item, index) => {
            const Icon = item.icon

            return (
              <article className={styles.card} key={item.title || index}>
                <div className={styles.cardHeading}>
                  {Icon && (
                    <span className={styles.icon} aria-hidden='true'>
                      <Icon />
                    </span>
                  )}
                  <div>
                    {item.label && <span className={styles.label}>{item.label}</span>}
                    <h3>{item.title}</h3>
                  </div>
                </div>

                {item.summary && <p className={styles.summary}>{item.summary}</p>}

                {item.points?.length > 0 && (
                  <ul className={styles.points}>
                    {item.points.map(point => <li key={point}>{point}</li>)}
                  </ul>
                )}

                {item.href && (
                  <Action
                    dataConversionChannel={item.conversionChannel}
                    dataConversionKey={item.conversionKey}
                    dataConversionLocation={item.conversionLocation || id}
                    dataConversionSalesPath={item.conversionSalesPath}
                    focusTargetOnNavigate={item.focusTargetOnNavigate}
                    href={item.href}
                    onClick={item.onClick}
                    variant={item.actionVariant || (isCompact ? 'secondary' : 'quiet')}
                    size='compact'
                    icon={FiArrowRight}
                    className={styles.action}
                  >
                    {item.actionLabel || 'Explore this option'}
                  </Action>
                )}
              </article>
            )
          })}
        </div>
      </Container>
    </section>
  )
}

export default VisualDecisionGuide
